import { Dealer, IEmployeeDetails } from '@common/interfaces';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IApiEmployee } from 'sales-types-common';

type EmployeeState = {
  employee: IApiEmployee;
  employeeDetails: IEmployeeDetails;
};

const initialState: EmployeeState = {
  employee: null,
  employeeDetails: {
    isMargin: false,
    isMarginAllowed: false,
    isIndependentDealerAllowed: false,
    isTestUser: false,
    isAdminAllowed: false,
    dealerRoleType: 'DEFAULT',
    dealerId: '',
    dealerIds: [],
    dealers: [],
  },
};

const employeeSlice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    setEmployee: (state, action: PayloadAction<IApiEmployee>) => {
      state.employee = action.payload;
    },
    setEmployeeDetails: (state, action: PayloadAction<IEmployeeDetails>) => {
      state.employeeDetails = action.payload;
    },
    setIsAdminAllowed: (state, action: PayloadAction<boolean>) => {
      state.employeeDetails.isAdminAllowed = action.payload;
    },
    setIsMargin: (state, action: PayloadAction<boolean>) => {
      state.employeeDetails.isMargin = action.payload;
    },
    setIsMarginAllowed: (state, action: PayloadAction<boolean>) => {
      state.employeeDetails.isMarginAllowed = action.payload;
    },
    setIsIndependentDealerAllowed: (state, action: PayloadAction<boolean>) => {
      state.employeeDetails.isIndependentDealerAllowed = action.payload;
    },
    setIsTestUser: (state, action: PayloadAction<boolean>) => {
      state.employeeDetails.isTestUser = action.payload;
    },
    setDealerRoleType: (state, action: PayloadAction<string>) => {
      state.employeeDetails.dealerRoleType = action.payload;
    },
    setDealerId: (state, action: PayloadAction<string>) => {
      state.employeeDetails.dealerId = action.payload;
    },
    setDealerIds: (state, action: PayloadAction<string[]>) => {
      state.employeeDetails.dealerIds = action.payload;
    },
    setDealers: (state, action: PayloadAction<Dealer[]>) => {
      state.employeeDetails.dealers = action.payload;
    },
  },
});

export const {
  setEmployee,
  setIsAdminAllowed,
  setIsMargin,
  setIsMarginAllowed,
  setIsIndependentDealerAllowed,
  setIsTestUser,
  setDealerRoleType,
  setEmployeeDetails,
  setDealerId,
  setDealerIds,
  setDealers,
} = employeeSlice.actions;
export default employeeSlice.reducer;
